import React, { useEffect, useState } from "react";
import { discount1, discount2, finallogo, check } from "../../imgUrl";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import image1 from "../../image/image1.jpg";
import image2 from "../../image/image2.jpg";
import image3 from "../../image/image3.jpg";
import image4 from "../../image/image4.jpg";
import image5 from "../../image/image5.jpg";
import image6 from "../../image/image6.jpg";
import image7 from "../../image/image7.jpg";
import image8 from "../../image/image8.jpg";
const staticData = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
];
const About = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const [data, setData] = useState(staticData);

  return (
    <div className="main-page-start">
      <div className="container ">
        <div>
          <div class="row">
            <div className="col-sm-7">
              <div class="brand-logo-main">
                <div
                  className="product-image-carousel d-flex product-form"
                  style={{ position: "relative" }}
                >
                  <div style={{ width: "80%" }}>
                    <Carousel
                      selectedItem={currentSlide}
                      onChange={setCurrentSlide}
                      showArrows={true}
                      showStatus={true}
                      showIndicators={true}
                      showThumbs={true}
                      useKeyboardArrows={true}
                      swipeable={true}
                      emulateTouch={true}
                    >
                      {data &&
                        data.map((image, index) => {
                          return (
                            <div key={index}   style={{
                                  height: "400px",
                                  overflowY: "auto",
                                  paddingRight: "0",
                                  scrollbarWidth: "none",
                                  msOverflowStyle: "none",
                                  marginTop:"10px",
                                  borderRadius:"5px"
                                }} >
                              <img
                                src={image}
                                alt={`Product image ${index}`}
                                class="promote-img" 
                              />
                              
                            </div>
                          );
                        })}
                    </Carousel>
                  </div>
                </div>
                {/* <img src={finallogo} /> */}
              </div>
            </div>
            <div className="col-sm-5">
              <div className="about-section">
                <h3>WHY CHOOSE US</h3>
                <p>
                  HEAR ARE THE REASONS WHY WELLJANHIT CHEMIST STAND OUT AS THE
                  ULTIMATE IN PARMRAMCY
                </p>
                <div className="about-peragraph">
                  <div className="about-item">
                    <div class="about-img-item">
                      <img className="about-img" src={check} />
                      <p>
                        WIDE RANGE OF GENUINE MEDICINES AND HEALTHCARE PRODUCTS{" "}
                      </p>
                    </div>
                  </div>
                  <div className="about-item">
                    <img className="about-img" src={check} />
                    <p>AFFORDABLE PRICES WITH A FOCUS ON QUALITY</p>
                  </div>
                  <div className="about-item">
                    <img className="about-img" src={check} />
                    <p>COMMITTED TO CUSTOMER HEALTH AND SATISFACTION</p>
                  </div>
                  <div className="about-item">
                    <img className="about-img" src={check} />
                    <p>CONVENIENT ORDERING AND TIMELY DELIVERY</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row three_box_about">
            <div className="col-sm-4">
              <div className="about-list">
                <h3>STORE LOCATION</h3>
                <ul>
                  <li>Ghatkopar</li>
                  <li>Mulund</li>
                  <li>Thane</li>
                  <li>Bandra</li>
                  <li>Andheri</li>
                  <li>Sakinaka</li>
                </ul>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="about-mission">
                <h3>OUR MISSION</h3>
                <p>
                  To provide every customer with safe,affordable, and
                  high-quality healthcare solutions,ensuring access to genuine
                  medicines and wellness products,while delivering exceptional
                  service and personalized care that improves lives.
                </p>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="about-support">
                <h3>COSTOMER SUPPORT / CONTACT US</h3>
                <p>Contact Us Anytime:</p>
                <p>Phone/WhatsApp:+91 88288 11673</p>
                <p>Email: support@welljanhitchemist.com</p>
                <p>Support Hours: Monady-Sunday,9:00AM-9:00PM</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
